import styles from '@fukku/input/Input.module.css'
import type { HintMessageProps } from '@fukku/input/types'
import textBodyS from '@fukku/styles/texts/textBodyS.module.css'
import { cx } from 'classix'
import { ClientLabel } from 'labels/components/ClientLabel/ClientLabel'

export function HintMessage({
	children,
	id,
	shouldRender,
	hintPlaceholders,
}: Readonly<HintMessageProps>) {
	if (!(children && shouldRender)) {
		return null
	}

	return (
		<p
			className={cx(textBodyS.className, styles.hint, styles.showHint)}
			id={id}
		>
			<ClientLabel placeholderValues={hintPlaceholders}>{children}</ClientLabel>
		</p>
	)
}
